import { Icon } from '@coop/components';
import { PlusIcon } from '@coop/icons';
import classNames from 'classnames';
import React from 'react';

import styles from './NumericStepper.module.scss';

const NumericStepperAddButton = React.forwardRef<
    HTMLButtonElement,
    React.ComponentPropsWithoutRef<'button'>
>((props, ref) => {
    const { className, ...otherProps } = props;

    return (
        <button
            ref={ref}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...otherProps}
            type="button"
            className={classNames(styles.Button, styles['Button--add'], className)}
            aria-label={props['aria-label'] || 'Öka antal'}
            data-testid="numericstepper-addbutton"
        >
            <Icon icon={<PlusIcon />} aria-hidden size="medium" />
        </button>
    );
});

export default NumericStepperAddButton;
